export const TALENT_PAGE_KEY = 'analytics-hub-dashboards-v2-talent' as const;
